import { render, staticRenderFns } from "./CancelledConnectionDetailsIcon.vue?vue&type=template&id=977037ae&scoped=true"
import script from "./CancelledConnectionDetailsIcon.vue?vue&type=script&lang=ts"
export * from "./CancelledConnectionDetailsIcon.vue?vue&type=script&lang=ts"
import style0 from "./CancelledConnectionDetailsIcon.vue?vue&type=style&index=0&id=977037ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977037ae",
  null
  
)

export default component.exports